function prefersReducedMotion() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

// Attach the <source data-src> and start playback for one deferred video.
function activateVideo(video) {
  const autoplayAllowed = !prefersReducedMotion();

  // Mobile and desktop videos are both in the DOM, one hidden by CSS.
  // Without this the hidden one downloads too, doubling the bytes.
  const isHidden = video.offsetWidth === 0 && video.offsetHeight === 0;
  if (isHidden) return;

  const wantsAutoplay = video.dataset.autoplay === "true";

  // Decorative video: for reduced motion, never attach the source — load()
  // buffers the whole file even at preload="none" (measured). Poster stays.
  if (wantsAutoplay && !autoplayAllowed) return;

  const sources = video.querySelectorAll("source[data-src]");
  if (sources.length === 0) return;

  sources.forEach((source) => {
    source.src = source.dataset.src;
    source.removeAttribute("data-src");
  });

  // Autoplay needs load() to actually fetch so loadeddata fires before play();
  // user-driven videos keep their lazy preload.
  if (wantsAutoplay) video.preload = "auto";

  video.load();

  if (wantsAutoplay) {
    // Play only after the first frame is decoded: play() clears the poster
    // immediately, so playing before a frame exists flashes gray. If refused
    // (low-power), low-power-video.js plays it on tap.
    const startPlayback = () => video.play().catch(() => {});
    if (video.readyState >= 2 /* HAVE_CURRENT_DATA */) {
      startPlayback();
    } else {
      video.addEventListener("loadeddata", startPlayback, { once: true });
    }

    // poster_as_img mode: video sits at opacity:0 over an <img> poster; reveal
    // it on "playing" (a frame is on screen) for a seamless handoff. No-op for
    // other videos (no .deferred-video__media rule).
    video.addEventListener(
      "playing",
      () => video.classList.add("is-playing"),
      { once: true },
    );
  }
}

function isNearViewport(el, margin) {
  const rect = el.getBoundingClientRect();
  return rect.top < window.innerHeight + margin && rect.bottom > -margin;
}

// Above-the-fold videos activate right after load; below-the-fold ones wait for
// first interaction, so heavy clips never stream on page load. IntersectionObserver
// is unreliable with this theme's custom scroll (measured), hence the manual check.
function setupDeferredVideos() {
  const videos = Array.from(
    document.querySelectorAll("video[data-deferred-video]"),
  );
  if (videos.length === 0) return;

  const remaining = [];
  videos.forEach((video) => {
    if (isNearViewport(video, 100)) {
      activateVideo(video);
    } else {
      remaining.push(video);
    }
  });

  if (remaining.length === 0) return;

  const events = ["scroll", "pointerdown", "touchstart", "keydown", "wheel"];
  const activateRest = () => {
    events.forEach((type) =>
      window.removeEventListener(type, activateRest, true),
    );
    remaining.forEach(activateVideo);
  };

  // capture:true — this theme's scroll happens on an inner element and the
  // scroll event does not bubble to window; only the capture phase sees it.
  events.forEach((type) =>
    window.addEventListener(type, activateRest, {
      capture: true,
      passive: true,
      once: true,
    }),
  );
}

if (document.readyState === "complete") {
  setupDeferredVideos();
} else {
  window.addEventListener("load", setupDeferredVideos);
}
